import { Button } from "@alch/ui";
import clsx from "clsx";
import errorStateSvgUrl from "../icons/error-state.svg";

type ErrorStateProps = {
  className?: string;
  onReload: () => void;
};

function ErrorState({ className, onReload }: ErrorStateProps) {
  return (
    <div
      className={clsx(
        "flex flex-col items-center justify-center gap-2",
        className,
      )}
    >
      <img src={errorStateSvgUrl} className="mb-4" />
      <h2 className="text-heading-h3 text-primary">Page could not be loaded</h2>
      <div className="text-secondary">
        Sorry about that! Reload the page to try again.
      </div>
      <Button className="mt-4" onClick={onReload}>
        Reload
      </Button>
    </div>
  );
}

export default ErrorState;
